export default {
    menu: {
        home: 'Strona główna',
        contact: 'Kontakt',
        offer: 'Oferta'
    },
    home: {
        intro: {
            firstTitle: 'PHU Miron',
            secondTitle: 'Używane jachty na sprzedaż',
            subtitle: 'Szeroki wybór jachtów motorowych, silników i przekładni.',
            offerLink: 'Zobacz naszą ofertę'
        },
        about: {
            title: '20 lat działalności.<br>Setki zadowolonych klientów.',
            content: {
                part1: `
Nasza firma zajmuje się sprowadzaniem używanych łodzi motorowych, silników i przekładni.
<br>Cechuje nas staranny wybór kupowanych jachtów i duża solidność w ich restaurowaniu.
<br>Wszystko po to, aby nasi klienci mogli cieszyć się wysoką jakością przy niskiej cenie.`,
                part2: 'Oferujemy szeroki wybór łodzi motorowych, takich jak:',
                list: [
                    'jachty wypornościowe i ślizgowe,',
                    'jachty kabinowe i otwarte (bez-kabinowe),',
                    'jachty wyścigowe (ślizgacze), sportowe i turystyczne,',
                    'jachty z silnikami stacjonarnymi (wbudowanymi) oraz z silnikami przyczepnymi.'
                ],
                summary: `
Dodatkowo sprowadzamy silniki do łodzi (stacjonarne lub zaburtowe), przekładnie,
a także różnego rodzaju sprzęty mechaniczne: pompy, transomy i inne.`
            }
        },
        contact: {
            title: 'Skontaktuj się z nami',
            phone: {
                title: 'Telefon',
                description: 'Zadzwoń i dowiedz się więcej.'
            },
            email: {
                title: 'Email',
                description: 'Nie masz czasu na dzwonienie?<br>Wyślij nam maila!'
            },
            address: {
                title: 'Adres',
                description: 'Szałkowo 28A<br>14-200 Iława',
                linkLabel: 'Zobacz na mapie'
            }
        }
    },
    offer: {
        title: 'Aktualna oferta',
        archive: {
            title: 'Archiwum',
            details: 'Szczegóły',
            goToArchive: 'Zobacz całe archiwum'
        }
    },
    archive: {
        title: 'Archiwum',
        pagedTitle: 'Strona {pageNumber} z Archiwum',
        goToOffer: 'Przejdź do aktualnej oferty',
        paging: {
            next: 'Następna',
            prev: 'Poprzednia',
            pageInfo: 'Strona {pageNumber} z {totalPages}'
        },
        details: {
            title: 'Archiwum',
            sold: 'Sprzedane'
        },
        loading: 'Trwa ładowanie'
    },
    item: {
        priceType: {
            INCLUDING_VAT: 'z VAT',
            EXCLUDING_VAT: '+ VAT',
            FREE_OF_VAT: '(zwolniony z VAT)'
        }
    },
    stickyOfferLink: {
        label: 'Zobacz aktualną ofertę'
    },
    notFound: {
        subtitle: 'Nie znaleźliśmy strony której szukasz.',
        goBack: 'Wróć',
        goToHome: 'Strona główna'
    }
};
